export class EmployersDirectoryService {
  constructor($resource, AuthService, ApiService, $cookies) {
    "ngInject";

    this.$cookies = $cookies;
    this.$resource = $resource;
    this.apiService = ApiService;
    this.authService = AuthService;

    //End Points
    this.getAllCityUrl = this.apiService.getResourceUrl(
      "/employeeDirectory/cities"
    );
    this.getAllIndustriesUrl = this.apiService.getResourceUrl(
      "/employeeDirectory/industries"
    );
    this.industriesWithIdUrl = this.apiService.getResourceUrl(
      "/employeeDirectory/industries/:group_id"
    );
    this.groupUrl = this.apiService.getResourceUrl("/employeeDirectory");
    this.groupWithIdUrl = this.apiService.getResourceUrl(
      "/employeeDirectory/:group_id"
    );
    this.filewithUuidUrl = this.apiService.getResourceUrl("/file/:uuid")

    //resources
    this.EmployersDirectoryResource = this.$resource(this.groupUrl, null, {
      getDetails: { method: "get" },
      create: { method: "post" },
    });

    //get By Id Resource
    this.individualGroupResourceWithId = this.$resource(
      this.groupWithIdUrl,
      null,
      {
        getDetails: { method: "get" },
        update: { method: "put" },
        delete: { method: "delete" },
      }
    );

    this.industriesWithIdResource = this.$resource(
      this.industriesWithIdUrl,
      null,
      { update : { method : "put"} }
    )

    this.getAllCitiesResource = this.$resource(this.getAllCityUrl, null, {
      getDetails: { method: "get" },
      create: { method: "post" },
    });

    this.getAllIndustriesResource = this.$resource(
      this.getAllIndustriesUrl,
      null,
      {
        getDetails: { method: "get" },
        create: { method: "post" },
      }
    );

    this.deleteFileByUuidResource = this.$resource(
         this.filewithUuidUrl,
         {
          delete: { method : "delete" }
         }
    )
  }

  getEmployersDirectoryList() {
    const promise = this.EmployersDirectoryResource.getDetails().$promise;
    return promise
      .then(({ details }) => details.companyList)
      .catch((error) => {
        // console.log("error", error);
        throw error;
      });
  }

  getGroupById(group_id) {
    const promise = this.individualGroupResourceWithId.getDetails({
      group_id,
    }).$promise;
    return promise
      .then(({ details }) => details)
      .catch((error) => {
        throw error;
      });
  }

  updateDetails(details, id, type) {
    const _promise =
      type === "add"
        ? this.EmployersDirectoryResource.create(details)
        : this.individualGroupResourceWithId.update(
            { group_id: id.companyDirectoryId },
            details
          );
    const promise = _promise.$promise;
    return promise
      .then((response) => response)
      .catch((error) => {
        throw error;
      });
  }

  deleteEmployersDirectoryIndividualGroup(id) {
    const promise = this.individualGroupResourceWithId.delete({
      group_id: id
    }).$promise;
    return promise
      .then((response) => response)
      .catch((error) => {
        throw error;
      });
  }

  getAllCities() {
    const promise = this.getAllCitiesResource.getDetails().$promise;
    return promise
      .then(({ details }) => details.cityList)
      .catch((error) => {
        // console.log("error", error);
        throw error;
      });
  }

  getAllIndustries() {
    const promise = this.getAllIndustriesResource.getDetails().$promise;
    return promise
      .then(({ details }) => details.industryList)
      .catch((error) => {
        // console.log("error", error);
        throw error;
      });
  }

  updateIndustriesById(details, id) {
    const _promise = this.industriesWithIdResource.update(
      { group_id: id },
      details
    );
    const promise = _promise.$promise;
    return promise
      .then(({ details }) => details)
      .catch((error) => {
        throw error;
      });
  }

  deleteFileUuid(uuid) {
     let _promise = this.deleteFileByUuidResource.delete({
         uuid: uuid
     })
     let promise = _promise.$promise
     return promise
     .then((res) => res)
     .catch((error) =>{
      throw error
     })
  }

}



// WEBPACK FOOTER //
// ./src/app/components/employers-directory/employers-directory.service.js